module.exports = __webpack_public_path__ + "img/pic.53708846.png";